import { IOperation, OperationType } from "actions/mutate";
import { BAG_VALUE_PARAMS_SEPARATOR, getAllocationBagKind } from "helpers/allocation-dimension";

export const getAllocationBagMutationPayload = (mutation: IOperation) => {
    const { childKey, key, value, operation } = mutation;
    const [, numKind] = childKey.split(BAG_VALUE_PARAMS_SEPARATOR);

    const strValue = value?.getIn(["string_value"]) ?? "";
    let valuePayload;
    if (operation === OperationType.Clear) {
        valuePayload = {
            kind: getAllocationBagKind(+numKind).toUpperCase(),
        };
    } else {
        valuePayload = {
            allocation_dimension_value: key.split(BAG_VALUE_PARAMS_SEPARATOR),
            quantity: strValue,
            kind: getAllocationBagKind(+numKind).toUpperCase(),
        };
    }

    return valuePayload;
};
